<template>
  <v-container>
    <v-row>
      <v-col class="text-center">
        <img alt="Vue logo" src="../../assets/logo.png" class="logo" style="height: 60px;">
        <h3>Credenciamento</h3>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <br />
    <h1>{{ project.title }}</h1>
    <v-stepper v-model="step">
      <v-stepper-header style="background-color: whitesmoke;">
        <v-stepper-step step="1">Projeto</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2">Dados do Cliente</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">Endereço</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4">Inversor (opcional)</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="5">Finalizado</v-stepper-step>
      </v-stepper-header>

      <v-stepper-content step="1">
        <h2 class="mb-4 d-md-none">Projeto</h2>
        <Project v-on:Step="stepChange"></Project>
      </v-stepper-content>

      <v-stepper-content step="2">
        <h2 class="mb-4 d-md-none">Dados do Cliente</h2>
        <Company v-on:Step="stepChange"></Company>
      </v-stepper-content>

      <v-stepper-content step="3">
        <h2 class="mb-4 d-md-none">Endereço</h2>
        <Address v-on:Step="stepChange"></Address>
      </v-stepper-content>

      <v-stepper-content step="4">
        <v-row>
          <v-col class="col-12 pt-0">
            <v-select
                :items="driversSelect"
                v-model="driver_id"
                label="Marca do inversor"
                class="bgalpha"
                hide-details
            ></v-select>
          </v-col>
          <v-col class="col-12">
            <v-text-field
                filled
                dense
                label="URL (endereço web)"
                autocomplete="url"
                name="url"
                v-model="url"
                :error-messages="errors.url"
                prepend-inner-icon="mdi-format-text"
                hide-details="auto"
                placeholder=" "
                type="text"
            ></v-text-field>
          </v-col>
          <v-col class="col-12 col-md-6">
            <v-text-field
                filled
                dense
                label="Login"
                autocomplete="login"
                name="login"
                v-model="login"
                :error-messages="errors.login"
                prepend-inner-icon="mdi-format-text"
                hide-details="auto"
                placeholder=" "
                type="text"
            ></v-text-field>
          </v-col>
          <v-col class="col-12 col-md-6">
            <v-text-field
                filled
                dense
                label="Senha"
                autocomplete="password"
                name="password"
                v-model="password"
                :error-messages="errors.password"
                prepend-inner-icon="mdi-format-text"
                hide-details="auto"
                placeholder=" "
                type="text"
            ></v-text-field>
          </v-col>
        </v-row>
        <div
            class="mt-5 pa-2 bgalpha text-right"
        >
          <v-btn
              color="gray"
              dark
              @click="stepChange(3)"
              :loading="editInverterState"
              class="mr-2"
          >
            Voltar
          </v-btn>
          <v-btn
              color="success"
              @click="dataloggerUpdate()"
              :loading="editInverterState"
          >
            Finalizar
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-content step="5" class="text-center">
        <h2>Seus dados foram recebidos</h2>
        <br />
        Em breve entraremos em contato
        <br />
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import Project from "@/views/credential/components/Project";
import Company from "@/views/credential/components/Company";
import Address from "@/views/credential/components/Address";

export default {
  components: {
    Project,
    Company,
    Address,
  },
  data() {
    return {
      project: {},

      errors: [],
      // step
      step: 1,
      // project
      title: '',
      // datalogger
      editInverterState: false,
      drivers: [],
      driver_id: 0,
      datalogger_id: 0,
      url: '',
      login: '',
      password: ''
    }
  },
  mounted() {
    this.projectInfo();
    this.driverLoad();
    this.dataloggerInfo();
  },
  watch: {
    driver_id(id) {
      const driver = this.drivers.find(d => d.id == id);
      if (driver) {
        this.url = driver.url;
      }
    }
  },
  methods: {
    stepChange(step) {
      this.step = step;
    },
    projectInfo() {
      const payload = {
        project_id: this.$route.params.project_id,
        project_uid: this.$route.params.project_uid,
      };

      this.$api
      .post('/project/project.info', payload)
      .then(response => {
        if (response.data.id) {
          this.project = response.data
        }
      });
    },
    driverLoad() {
      this.$api
          .post('/driver/driver.list')
          .then(response => {
            this.drivers = response.data;
          });
    },
    dataloggerInfo() {
      const payload = {
        project_id: this.$route.params.project_id,
        project_uid: this.$route.params.project_uid,
      };

      this.$api
          .post('/project/datalogger.info', payload)
          .then(response => {
            this.datalogger_id = response.data.id;
            this.driver_id = response.data.driver_id;
            this.url = response.data.url;
            this.login = response.data.login;
            this.password = response.data.password;
          });
    },
    dataloggerUpdate() {
      const payload = {
        project_id: this.$route.params.project_id,
        project_uid: this.$route.params.project_uid,

        driver_id: this.driver_id,
        url: this.url,
        login: this.login,
        password: this.password
      }

      this.$api
          .post('/project/datalogger.update', payload)
          .then(response => {
            this.errors = [];

            if (response.data.id) {
              this.id = response.data.id;

              this.stepChange(5);
            }
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          })
          .finally(() => {
            this.editState = false;
          });
    }
  },
  computed: {
    driversSelect() {

      const drivers = this.drivers.map((item) => {
        return {
          text: item.title,
          value: item.id
        }
      });

      return [
        ...drivers,
        {
          text: 'Outro',
          value: 0,
        }
      ]
    }
  },
}
</script>

<style>

</style>